<template>
  <div class="mypage__mb">
    <div class="mypage__upload text-center w-100">
      <div class="avatar avatar-edit">
        <img :src="editMyPage.avatar" alt class="avt-modal" ref="displayImage" />
        <div class="input-upload">
          <label for="uploadfile" class="label-upload"></label>
          <input type="file" id="uploadfile" name="uploadfile" class="btn-file input-0"  @change="changeImage($event)"/>
        </div>
      </div>
      <ModalErrorUploadImage @hidePopupImage="hidePopupImage" :avatarError="avatarError"/>
    </div>
    <div class="mypage__title title-edit text-center">
      {{truncate(user.name,20,'...')}}
    </div>
    <div class="mypage__job text-center">{{user.position}}</div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {MESSAGE} from '@/utils/errorjapanese'
import ModalErrorUploadImage from '@/components/share/ErrorUploadImage'
export default {
  name: 'BreadcrumbMyPage',
  components: {
    ModalErrorUploadImage
  },
  data () {
    return {
      avatarError: ''
    }
  },
  methods: {
    changeImage (event) {
      if (/\.(jpg|jpeg|png|bmp|gif)$/.test(event.target.files[0].name) && event.target.files[0].size <= 5242880) {
        this.editMyPage.avatar = event.target.files[0]
        let reader = new FileReader()
        reader.addEventListener('load', function () {
          this.$refs.displayImage.src = reader.result
        }.bind(this), false)
        reader.readAsDataURL(this.editMyPage.avatar)
      } else {
        event.target.value = ''
        this.avatarError = MESSAGE.AVATAR_FORMAT
        this.$root.$emit('bv::show::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
      }
    },
    hidePopupImage () {
      this.avatarError = ''
      this.$root.$emit('bv::hide::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
    }
  },

  computed: {
    ...mapState({
      user: state => state.allAuth.user,
      editMyPage: state => state.allAuth.editMyPage
    })
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/MyPage/SideBarEditMyPage.vue